import React, { use, useState } from 'react'
import { BreadCrumb } from 'primereact/breadcrumb'
import { useSelector } from 'react-redux'

import MobileSibeBar from './MobileSibeBar'
import ProfileDropdown from './ProfileDropdown'
import CustomChip from '../../shared/CustomChip'
import { GoDotFill } from 'react-icons/go'
import CheckPermission from '../../hooks/CheckPermission'
import { useTranslation } from 'react-i18next'
import LangSwitcher from './LangSwitcher'
import PatientSearchFeild from './PatientSearchFeild'
import { useLocation } from 'react-router-dom'
import { CurrentVersion } from '../../config'

const Navbar = ({ activeSection }) => {
  const { i18n } = useTranslation()
  const [openMobileSidebar, setOpenMobileSidebar] = useState(false)
  const { user } = useSelector(state => state?.auth)
  const { counterStatus } = useSelector(state => state?.counter)
  const { hasPermission } = CheckPermission()
  const location = useLocation()
  const { t } = useTranslation()
  return (
    <nav
      className={`flex 
       bg-white
       h-[50px] w-full items-center md:px-4 px-4 relative`}
    >
      <div className='flex items-center md:ml-[5px]'>
        <i
          className='!text-primary !text-[20px] block cursor-pointer md:hidden me-3 pi pi-bars'
          onClick={() => setOpenMobileSidebar(true)}
        />
        <div className='flex gap-2 justify-center items-center'>
          <img
            src='/images/supergit-03.png'
            className='w-10 cursor-pointer lg:w-10'
            alt='SuperGIT'
          />
          <span className='text-18-dark'>
            {t('SUPER-GIT')} v{CurrentVersion}
          </span>
        </div>
      </div>
      <div
        className={`w-fit hidden ${i18n.language === 'en'
          ? 'lg:ml-[150px] md:ml-4'
          : 'lg:mr-[150px] md:mr-4'
          } relative md:block`}
      >
        <BreadCrumb
          pt={{
            root: { className: '!bg-transparent !border-0' },
            action: { className: '!text-[18px] font-[600] capitalize' },
            icon: { className: 'text-white !text-[18px] me-2' },
            menuitem: {
              className: '!text-white !text-[18px] font-[600] capitalize'
            },
            label: { className: 'text-white' },
            separatoricon: { className: '!text-white w-[16px] h-[16px]' }
          }}
        />
      </div>

      <div
        className={`flex gap-2 items-center justify-end ${i18n.language === 'en' ? 'ml-auto' : 'mr-auto'
          }`}
      >
        <div
          className={`flex  ${user?.role?.name_en === 'Admin' ||
            user?.role?.name_en === 'Practitioner'
            ? 'items-center justify-end'
            : 'items-end justify-end'
            } w-full gap-2`}
        >
          {hasPermission("patient", 'get') && <PatientSearchFeild />}
          {hasPermission('counter', 'get') && (
            <CustomChip
              chipType={counterStatus === 'closed' ? 'danger' : 'success'}
              label={counterStatus}
              icon={<GoDotFill size={15} className='me-1' />}
              className='h-[30px] rounded-full min-w-[90px] justify-center capitalize'
            />
          )}
          <LangSwitcher />
          <ProfileDropdown />
        </div>
      </div>
      <MobileSibeBar
        openMobileSidebar={openMobileSidebar}
        setOpenMobileSidebar={setOpenMobileSidebar}
      />
    </nav>
  )
}

export default Navbar
